export const ADDONS_URL = process.env.REACT_APP_ADDONS_URL
export const ADDONS_ENABLED = process.env.REACT_APP_ADDONS_ENABLED
export const HOSTING_DOMAIN =
  process.env.REACT_APP_HOSTING_DOMAIN || 'hosting.adalo.com'

export const MANUAL_AUTH_PROVIDER = 'manual'
export const GOOGLE_AUTH_PROVIDER = 'google'
